import { Component, OnInit } from '@angular/core';
import { faCheck, faCheckCircle, faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef, ModalOptions } from "ngx-bootstrap/modal";

@Component({
  selector: 'app-amenities-modal',
  templateUrl: './amenities-modal.component.html',
  styleUrls: ['./amenities-modal.component.scss']
})
export class AmenitiesModalComponent implements OnInit {
  icons = {
    check: faCheck,
    info: faInfoCircle,
    circleCheck: faCheckCircle,


  }
  amenities: any;
  constructor(
    public bsModalRef: BsModalRef,
    public options: ModalOptions,

  ) {
    this.amenities = this.options?.initialState?.data;
    console.log(this.amenities)
   }

  ngOnInit(): void {
  }

  closeModal() {
    this.bsModalRef.hide();

  }

}
